import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import _ from 'lodash'

Vue.use(Vuex)

const apiURL = process.env.VUE_APP_API_URL

export default new Vuex.Store({
    state: {
        works: {
            photos: null,
            videos: null,
            showcased: null
        },
        mobileMenuActive: false,
        appContent:null,
        infopageContent:null
    },
    mutations: {
        setPhotos: (state, payload) => {
            state.works.photos = payload
        },
        setVideos: (state, payload) => {
            state.works.videos = payload
        },
        setShowcased: (state) => {
            let showcasedVideos = _.filter(state.works.videos, {'showcase': true})
            for (const showcasedVideo of showcasedVideos) {
                showcasedVideo.workType = "video"
            }
            let showcasedPhotos = _.filter(state.works.photos, {'showcase': true})
            for (const showcasedPhoto of showcasedPhotos) {
                showcasedPhoto.workType = "photo"
            }
            let showcasedWorks = _.concat(showcasedPhotos, showcasedVideos)
            var showcasedWorksSorted = _.orderBy(showcasedWorks, 'updated_at', 'desc')
            //TODO ORDERING
            state.works.showcased = showcasedWorksSorted
        },
        setEditorialWorks: (state, payload) => {
        }
        ,
        activateMobileMenu: (state) => {
            state.mobileMenuActive = true
        },
        deactivateMobileMenu: (state) => {
            state.mobileMenuActive = false
        },
        setAppContent:(state,payload)=>{
            state.appContent=payload
        },
        setInfopageContent:(state,payload)=>{
            state.infopageContent=payload
        }
    },
    actions: {
        GET_PHOTOS_FROM_API({commit}) {
            axios.get(apiURL + '/photos').then(response => {
                var works = response.data
                for (const work of works) {
                    work.projectType = "photo"
                }
                commit('setPhotos', response.data)
                commit('setShowcased')
            })
        },
        GET_VIDEOS_FROM_API({commit}) {
            axios.get(apiURL + '/videos').then(response => {
                var works = response.data
                for (const work of works) {
                    work.projectType = "video"
                }
                commit('setVideos', response.data)
                commit('setShowcased')

            })
        },
        GET_APPCONTENT_FROM_API({commit}){
            axios.get(apiURL+'/appcontent').then(response=>{
                commit('setAppContent',response.data)
            })
        },
        GET_INFOPAGE_CONTENT_FROM_API({commit}){
            axios.get(apiURL+'/infopage').then(response=>{
                commit('setInfopageContent',response.data.contentwrapper)
            })
        }
    },
    modules: {}
})
